export default __webpack_public_path__ + "static/media/arrowRightSmallIcon.2710f764.svg";